var ISOFormatHoursIndex = 11;
var ISOFormatMinutesIndex = 14;
var ISOFormatMinutesSingleDigitIndex = 15;
var ISOFormatHoursLength = 8;
var ISOFormatMinutesLength = 5;
var ISOFormatMinutesSingleDigitLength = 4;
export var MAX_SECONDS = 8640000000000; //  https://262.ecma-international.org/5.1/#sec-15.9.1.1
var validSeconds = function (seconds) {
    return seconds > MAX_SECONDS ? 0 : seconds;
};
export var secondsToISO = function (seconds, isLoaded, duration) {
    if (!isLoaded) {
        return '--:--';
    }
    try {
        var durationMinutes = Math.floor(duration / 60);
        var durationHours = Math.floor(durationMinutes / 60);
        var secondsInISOFormat = new Date(validSeconds(seconds) * 1000).toISOString();
        if (durationHours > 0) {
            return secondsInISOFormat.substr(ISOFormatHoursIndex, ISOFormatHoursLength);
        }
        if (durationMinutes > 9) {
            return secondsInISOFormat.substr(ISOFormatMinutesIndex, ISOFormatMinutesLength);
        }
        return secondsInISOFormat.substr(ISOFormatMinutesSingleDigitIndex, ISOFormatMinutesSingleDigitLength);
    }
    catch (ex) {
        return '--:--';
    }
};
export var positionToSeconds = function (positionInPercentage, durationInSeconds) {
    return (positionInPercentage / 100) * durationInSeconds;
};
export var secondsToPosition = function (seekInSeconds, durationInSeconds) {
    return (seekInSeconds / durationInSeconds) * 100;
};
//# sourceMappingURL=utils.js.map